import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'

export default {
	/**
	 * Lora空开列表接口
	 * @param {page} 第几页
	 * @return {pageSize} 每页数量
	**/
	airOpenList( params={} ) {
		return request({
	    url: baseUrl + '/breaker/index',
	    method: 'GET',
	    params
	  })
	},
	/**
	 * Lora空开添加接口
	**/
    airOpenAdd(data) {
		return request({
	    url: baseUrl + '/breaker/add',
	    method: 'POST',
	    data
	  })
	},
	/**
	 * Lora空开编辑接口
	**/
	airOpenEdit(id,data){
		return request({
			url: baseUrl + '/breaker/edit/'+id,
			method:'PUT',
			data
		})
	},
	/**
	 * 删除Lora空开接口
	**/
	airOpenDel(id){
		return request({
			url: baseUrl + '/breaker/destroy/'+id,
			method:'DELETE'
		})
	},

	/**
	 * Lora空开开关闸
	**/
	airOpenControl(id,data){
		return request({
			url: baseUrl + '/breaker/control/'+id,
			method:'POST',
			data
		})
	}
}